import { render } from "./smartOMDetailofPaperMaking.vue?vue&type=template&id=4078c78e"
import script from "./smartOMDetailofPaperMaking.vue?vue&type=script&lang=js"
export * from "./smartOMDetailofPaperMaking.vue?vue&type=script&lang=js"

import "./smartOMDetailofPaperMaking.vue?vue&type=style&index=0&id=4078c78e&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__